'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Nachwuchsfoerderung = require('../entity').Nachwuchsfoerderung;

module.exports = function (connection) {
  return {
    byTitelLike: function byTitelLike(titel, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byTitelLike', 'titel')(titel, additionalParams);
    },
    byNachwuchsfoerderungsTypEquals: function byNachwuchsfoerderungsTypEquals(nachwuchsfoerderungstyp, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byNachwuchsfoerderungsTypEquals', 'nachwuchsfoerderungstyp')(nachwuchsfoerderungstyp, additionalParams);
    },
    byForschungsprojektEquals: function byForschungsprojektEquals(forschungsprojekt, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byForschungsprojektEquals', 'forschungsprojekt')(forschungsprojekt, additionalParams);
    },
    byStrukturiertesPromotionsprogrammEquals: function byStrukturiertesPromotionsprogrammEquals(strukturiertespromotionsprogramm, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byStrukturiertesPromotionsprogrammEquals', 'strukturiertespromotionsprogramm')(strukturiertespromotionsprogramm, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    byInPromotionsprogrammEquals: function byInPromotionsprogrammEquals(inpromotionsprogramm, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byInPromotionsprogrammEquals', 'inpromotionsprogramm')(inpromotionsprogramm, additionalParams);
    },
    byErstbetreuerEquals: function byErstbetreuerEquals(erstbetreuer, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byErstbetreuerEquals', 'erstbetreuer')(erstbetreuer, additionalParams);
    },
    byKooperationEquals: function byKooperationEquals(kooperation, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byKooperationEquals', 'kooperation')(kooperation, additionalParams);
    },
    byPromotandEquals: function byPromotandEquals(promotand, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byPromotandEquals', 'promotand')(promotand, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'findAll', 'page')(page, additionalParams);
    },
    byAbgeschlossenEquals: function byAbgeschlossenEquals(abgeschlossen, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byAbgeschlossenEquals', 'abgeschlossen')(abgeschlossen, additionalParams);
    },
    byTitelEquals: function byTitelEquals(titel, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byTitelEquals', 'titel')(titel, additionalParams);
    },
    findOne: function findOne(projection, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'findOne', 'projection')(projection, additionalParams);
    },
    byIstFinalEquals: function byIstFinalEquals(istfinal, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byIstFinalEquals', 'istfinal')(istfinal, additionalParams);
    },
    byInForschungsprojektEquals: function byInForschungsprojektEquals(inforschungsprojekt, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'byInForschungsprojektEquals', 'inforschungsprojekt')(inforschungsprojekt, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Nachwuchsfoerderung, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Nachwuchsfoerderung, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('nachwuchsfoerderung')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/nachwuchsfoerderung.js
// module id = qzmm
// module chunks = 0